import store from '../store';
import qs from 'qs';

/**
 * 用户登录API
 */
export default {
    /**
     * 登录
     */
    async login (payload) {
        const API = '/call-platform/systemUsers/login';
        let headers = { 'Content-Type': 'application/json' };
        let body = JSON.stringify(payload);
        let resp = await fetch(API, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 用户修改密码
     */
    async changePass (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/systemUsers/changePassword';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let body = JSON.stringify(payload);
        let resp = await fetch(API, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 获取在线用户人数
     */
    async getOnlineUser () {
        let token = store.state.account.token;
        const API = '/call-platform/systemUsers/getOnlineUser';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 分页查询用户列表
     */
    async getUserListPage (payload) {
        let token = store.state.account.token;
        if (!payload) payload = {};
        var params = qs.stringify(payload);
        const API = '/call-platform/systemUsers/page?' + params;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 注册
     */
    async register (payload) {
        const API = '/call-platform/systemUsersRegisterApprove/register';
        let headers = { 'Content-Type': 'application/json' };
        let body = JSON.stringify(payload);
        let resp = await fetch(API, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 更新用户状态
     */
    async updateStatus (payload) {
        let token = store.state.account.token;
        if (!payload) payload = {};
        var params = qs.stringify(payload);
        const API = '/call-platform/systemUsers/updateStatus?' + params;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 新增用户
     */
    async addUser (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/systemUsers/add';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let body = JSON.stringify(payload);
        let resp = await fetch(API, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 分页查询用户注册审批记录
     */
    async getUsersRegisterApproveList (payload) {
        let token = store.state.account.token;
        if (!payload) payload = {};
        var params = qs.stringify(payload);
        const API = '/call-platform/systemUsersRegisterApprove/page?' + params;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 审批用户注册
     */
    async approveRegister (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/systemUsersRegisterApprove/approveRegister';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let body = JSON.stringify(payload);
        let resp = await fetch(API, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    }

};
